'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatSlackChannelReference = channel => new ReferenceRecord({
  id: channel.id,
  label: `#${channel.name}`,
  referencedObject: channel
});
export const formatSlackChannels = response => {
  return List(response.map(formatSlackChannelReference));
};
export const formatSlackChannelsMap = response => indexBy(get('id'), formatSlackChannels(response));